// Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/Login.css"

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Authentication placeholder logic
    if (username && password) {
      console.log('User logged in:', username);
      navigate('/notebookhome');
    } else {
      alert('Please enter a username and password.');
    }
  };

  return (
    <div className= "login-container">
      <h1>Login</h1>
      <form onSubmit={handleLogin} className ="login-form">
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="login-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
        />
        <button type="submit" className="login-button">Login</button>
      </form>
    </div>
  );
};

export default Login;
